<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>网抓文件查询</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      网抓门店文件查询
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="view-filter">
          <el-form :inline="true" :model="filterForm" size="small">
            <el-form-item label="时间筛选">
              <el-date-picker
                value-format="yyyy-MM-dd"
                size="small"
                v-model="filterForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="抓取类型">
              <el-select
                v-model="filterForm.scrap_type" placeholder="选择抓取类型">
                <el-option label="全部" value="0"></el-option>
                <el-option v-for="(value,key,index) in scrap" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务类型">
              <el-select size="small" v-model="filterForm.data_type" placeholder="任务类型">
                <el-option :label="item.label" :value="item.value" v-for="item in dataTypeList"
                           :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="filterForm.search_text" class="search-text" size="small" placeholder="任务文件名称">
                <el-button slot="append" @click="onSearch">查找</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="card-content">
          <div class="table-tool">共{{totalCount}}条</div>
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="create_time"
              label="抓取时间">
            </el-table-column>
            <el-table-column
              prop="scrap_type"
              label="抓取类型">
              <template slot-scope="scope">
                <span>{{scrap[scope.row.scrap_type]}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="data_type"
              label="任务类型">
              <template slot-scope="scope">
                {{{
                1: '销售',
                3: '采购',
                2: '库存',
              }[scope.row.data_type]}}
              </template>
            </el-table-column>
            <el-table-column
              prop="count"
              label="条数">
            </el-table-column>
            <el-table-column
              prop="file_name"
              label="文件名">
              <template slot-scope="scope">
                <a href="javascript:;" @click="onDownload(scope.row)">{{scope.row.file_name}}</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block" v-if="totalPage>1">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {getWebScrapList} from '@/api/index';
import {uploadDetailExport} from '@/api/export';

export default {
  name: "WebScrap",
  data() {
    return {
      currentPage: 1,
      totalCount: 0,
      searchText: '',
      tableData: [],
      totalPage: 1,
      dataTypeList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '销售',
          value: '1'
        },
        {
          label: '采购',
          value: '3'
        },
        {
          label: '库存',
          value: '2'
        }
      ],
      filterForm: {
        date: [],
        data_type: '',
        search_text: '',
        is_stores:'1'
      },

      scrap:{
        1:"网站抓取",
        2:"Web service"
      }
    }
  },
  created() {
    this._getList(1);
  },
  methods: {
    _getList(page) {
      let filterForm = {...this.filterForm};
      if (filterForm.date && filterForm.date !== '') {
        filterForm.start_time = filterForm.date[0];
        filterForm.end_time = filterForm.date[1];
      } else {
        filterForm.start_time = '';
        filterForm.end_time = '';
      }
      delete filterForm.date;

      filterForm.page = page;
      getWebScrapList(filterForm).then(res => {
        if (0 === res.status) {
          this.tableData = res.data.list;
          this.totalCount = res.data.totalCount;
          this.currentPage = parseInt(res.data.currentPage);
          this.totalPage = res.data.totalPage;
        } else {
          this.tableData = [];
          this.currentPage = 1;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      })
    },
    onSearch() {
      this._getList(1);
    },
    handleCurrentChange(val) {
      this._getList(val);
    },
    onDownload({flow_upload_id}) {
      console.log(flow_upload_id);
      uploadDetailExport(flow_upload_id);
    }
  }
}
</script>

<style scoped>

</style>